import {ListProvider} from "base/entity/provider";
import {ModuleLayout} from "base/ui/module/components";
import {ModuleConfigProvider} from "base/ui/module/provider";
import {DomainProvider} from "snimf/domain/provider";
import {PlotPageMenu} from "plot/menu";

const PlotModule = () => {
    return (
        <ModuleConfigProvider>
            <DomainProvider>
                <ListProvider>
                    <ModuleLayout menu={<PlotPageMenu />} />
                </ListProvider>
            </DomainProvider>
        </ModuleConfigProvider>
    );
};

export default PlotModule;
